import { useRef } from 'react';

interface UseRenderContentParams {
  isExpanded: boolean;
  keepContentWhenCollapsed?: boolean;
}

export const useRenderContent = ({
  isExpanded,
  keepContentWhenCollapsed,
}: UseRenderContentParams) => {
  const hasRenderedContentRef = useRef(isExpanded);

  if (isExpanded && !hasRenderedContentRef.current) {
    hasRenderedContentRef.current = true;
  }

  return (keepContentWhenCollapsed && hasRenderedContentRef.current) || isExpanded;
};
